/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1DeleteTaxoparkWithdrawalSecretRequest } from '../../entities/v1/DeleteTaxoparkWithdrawalSecretRequest'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1DeleteTaxoparkWithdrawalSecretRequestSchema = z.object({
  provider_id: z.number().int(),
}) as unknown as ToZod<V1DeleteTaxoparkWithdrawalSecretRequest>